<template lang="pug">
b-modal(
  v-model="show"
  title="Editar datos del cliente"
  size="lg"
  @ok.prevent="guardar"
  ok-title="Guardar"
  cancel-title="Cancelar"
  :ok-disabled="loading"
  :cancel-disabled="loading"
  no-enforce-focus
)
  b-alert(variant="warning" show dismissible)
    | Estos datos son del cliente y se actualizarán en todas sus OTs/OVs asociadas.
  b-form
    b-row
      b-col(cols="12" md="6")
        b-form-group(label="RUT" label-for="edit-rut")
          b-form-input#edit-rut(v-model="form.rut" placeholder="Ej: 12345678-9")
      b-col(cols="12" md="6" v-if="!isEmpresa")
        b-form-group(label="Nombre" label-for="edit-nombre")
          b-form-input#edit-nombre(v-model="form.nombre" placeholder="Nombre")
    b-row(v-if="!isEmpresa")
      b-col(cols="12" md="6")
        b-form-group(label="Apellido" label-for="edit-apellido")
          b-form-input#edit-apellido(v-model="form.apellido" placeholder="Apellido")
      b-col(cols="12" md="6")
        b-form-group(label="Dirección" label-for="edit-direccion")
          b-form-input#edit-direccion(v-model="form.direccion" placeholder="Dirección")
    b-row(v-if="isEmpresa")
      b-col(cols="12" md="6")
        b-form-group(label="Razón Social" label-for="edit-razon-social")
          b-form-input#edit-razon-social(v-model="form.nombre" placeholder="Razón Social")
      b-col(cols="12" md="6")
        b-form-group(label="Dirección" label-for="edit-direccion-empresa")
          b-form-input#edit-direccion-empresa(v-model="form.direccion" placeholder="Dirección")
    b-row
      b-col(cols="12" md="6")
        b-form-group(label="Correo Electrónico" label-for="edit-correo")
          b-form-input#edit-correo(v-model="form.email" type="email" placeholder="correo@ejemplo.com")
      b-col(cols="12" md="6")
        b-form-group(label="Teléfono" label-for="edit-telefono")
          b-form-input#edit-telefono(v-model="form.telefono" placeholder="+56 9 1234 5678")
    b-row
      b-col(cols="12" md="6")
        b-form-group(label="Región" label-for="edit-region")
          b-form-select#edit-region(
            v-model="form.region"
            :options="regionOptions"
            @change="form.comuna = null"
          )
      b-col(cols="12" md="6")
        b-form-group(label="Comuna" label-for="edit-comuna")
          b-form-select#edit-comuna(
            v-model="form.comuna"
            :options="comunaOptions"
            :disabled="!form.region"
          )
  template(#modal-footer)
    b-button(variant="light" @click="show = false" :disabled="loading") Cancelar
    b-button(variant="primary" @click="guardar" :disabled="loading")
      b-spinner(v-if="loading" small)
      span(v-else) Guardar
</template>

<script>
import axios from '@/plugins/axios'
import { regionesComunaOptions } from '@/components/OT/NewOT/options'

export default {
  name: 'EditClienteOVModal',
  props: {
    ov: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        rut: '',
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        region: null,
        comuna: null,
        direccion: '',
      },
    }
  },
  computed: {
    show: {
      get() { return this.value },
      set(val) { this.$emit('input', val) },
    },
    isEmpresa() {
      return this.ov.datos_cliente?.cliente_tipo === 'empresa'
    },
    regionOptions() {
      return [
        { value: null, text: 'Seleccione una región' },
        ...regionesComunaOptions.map((r) => ({ value: r.region, text: r.region })),
      ]
    },
    comunaOptions() {
      if (!this.form.region) return [{ value: null, text: 'Seleccione región' }]
      const found = regionesComunaOptions.find((r) => r.region === this.form.region)
      if (!found) return [{ value: null, text: 'Seleccione' }]
      return [
        { value: null, text: 'Seleccione una comuna' },
        ...found.comunas.map((c) => ({ value: c, text: c })),
      ]
    },
  },
  watch: {
    value(val) {
      if (val) this.initForm()
    },
  },
  methods: {
    initForm() {
      const d = this.ov.datos_cliente || {}
      this.form = {
        rut: this.ov.rut || d.rut || '',
        nombre: this.ov.nombre || d.nombre || '',
        apellido: this.ov.apellido || d.apellido || '',
        email: this.ov.correo_electronico || d.correo_electronico || '',
        telefono: this.ov.telefono || d.telefono || '',
        region: this.ov.region || d.region || null,
        comuna: this.ov.comuna || d.comuna || null,
        direccion: this.ov.direccion || d.direccion || '',
      }
    },
    async guardar() {
      this.loading = true
      try {
        const clienteId = this.ov.cliente
        const payload = {
          tipo_cliente: this.isEmpresa ? 2 : 1,
          rut: this.form.rut,
          nombre: this.form.nombre,
          apellido: this.form.apellido,
          email: this.form.email,
          telefono: this.form.telefono,
          region: this.form.region,
          comuna: this.form.comuna,
          direccion: this.form.direccion,
        }
        const { key } = JSON.parse(localStorage.getItem('user'))
        await axios.put(`/api/clientes/${clienteId}`, payload, {
          headers: { Authorization: `Token ${key}` },
        })
        this.$bvToast.toast('Datos del cliente actualizados correctamente.', { variant: 'success' })
        this.show = false
        this.$emit('saved')
      } catch (error) {
        this.$bvToast.toast('Error al actualizar los datos del cliente.', { variant: 'danger' })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
